import React from 'react'

export default function RenderDescricao( ficha, el, data ) {
    console.log(el)
    if (el.tipoinfracao === "1 - Estágio não obrigatório do curso de Fisioterapia em quantitativo acima do permitido na Resolução 432/2013") {
        return (
            <>
                Identificado, através de fiscalização técnica
                (conforme o Termo de Visita Nº {ficha.dadosEstabelecimento[0].uf || null} {ficha.dadosIniciais[0].tv}/{data}), que a clínica recebe estágio
                extra-curricular do curso de Fisioterapia em quantitativo acima do permitido
                na Resolução 432/2013.
            </>
        )
    }
    else if (el.tipoinfracao === "2 - Estágio obrigatório de acadêmicos(as) do curso de Fisioterapia com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de
                Visita  No  {ficha.dadosIniciais[0].tv}/{data}), que o(a) {el.localestagio} recebe estágio obrigatório de
                acadêmicos(as) do curso de Fisioterapia com ausência de acompanhamento de docente da
                Instituição de Ensino Superior (IES).
            </>
        )
    }
    else if (el.tipoinfracao === "3 - Exercício ilegal da profissão de fisioterapeuta.") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o TV
                Nº {ficha.dadosIniciais[0].tv}/{data}), o exercício ilegal da profissão de fisioterapeuta.
            </>
        )
    }
    else if (el.tipoinfracao === "4 - Prática de atividades da Fisioterapia por pessoa não habilitada.") {
        return (
            <>
                De acordo com o ato fiscalizatório, realizado no
                estabelecimento acima e relatado no Termo de Visita {ficha.dadosIniciais[0].tv}/{data}
                , há prática de atividades da Fisioterapia por pessoa não habilitada.
            </>
        )
    }
    else if (el.tipoinfracao === "5 - Delegação de função privativa do profissional fisioterapeuta.") {
        return (
            <>
                Através de fiscalização técnica, foi identificado a delegação de função privativa
                do profissional fisioterapeuta, conforme o Termo de Visita  Nº {ficha.dadosIniciais[0].tv}/{data}.
            </>
        )
    }
    else if (el.tipoinfracao === "6 - Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço.") {
        return (
            <>
                De acordo com o ato fiscalizatório, realizado no estabelecimento acima e relatado
                no Termo de Visita  nº {ficha.dadosIniciais[0].tv}/{data} foi identificado que a empresa não possui a Declaração de Regularidade
                para Funcionamento (DRF) do serviço.
            </>
        )
    }
    else if (el.tipoinfracao === "7 - Ausência do responsável técnico de Fisioterapia.") {
        return (
            <>
                Identificado, através de fiscalização técnica conforme o Termo de
                Visita Nº {ficha.dadosIniciais[0].tv}/{data} o descumprimento da legislação referente a ausência do responsável técnico de
                Fisioterapia.
            </>
        )
    }
    else if (el.tipoinfracao === "8 - Profissional com Licença Temporária de Fisioterapia vencida.") {
        var dataLtf = `${el.vencimento.slice(8, 10)}/${el.vencimento.slice(5, 7)}/${el.vencimento.slice(0, 4)}`
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de Visita
                Nº {ficha.dadosIniciais[0].tv}/{data}), que há atuação de profissional com Licença Temporária de Fisioterapia vencida
                desde {dataLtf}.
            </>
        )
    }
    else if (el.tipoinfracao === "9 - Falta de registro das atividades assistenciais fisioterapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo fisioterapeuta, da guarda e do seu descarte. (Responsável Técnico)") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de
                Visita {ficha.dadosIniciais[0].tv}/{data}), o descumprimento da legislação referente ao registro das atividades
                assistenciais fisioterapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário
                pelo fisioterapeuta, da guarda e do seu descarte.
            </>
        )
    }
    // else if (el.tipoinfracao === "10 - Descumprimento a RDC-07.") {
    //     return (
    //         <>
    //             Verificado, durante fiscalização (conforme o Termo de Visita
    //             Nº {ficha.dadosIniciais[0].tv}/{data}), que os setores da(s) {el.setores} se encontram descobertos de
    //             profissional de fisioterapia durante os turnos {el.turnos}.
    //         </>
    //     )
    // }
    else if (el.tipoinfracao === "10 - Falta de registro de consultório.") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de Visita Nº {ficha.dadosIniciais[0].tv}/{data}),
                a falta de registro de consultório junto ao CREFITO-1.
            </>
        )
    }
    else if (el.tipoinfracao === "11 - Débitos com obrigações pecuniárias.") {
        return (
            <>
                Identificado, através de levantamento financeiro do sistema cadastral deste Conselho
                Regional, que o (a) profissional supracitado (a) encontra-se em débito, com as obrigações pecuniárias,
                a seguir indicadas: Anuidades {el.anuidades}, (com os acrécimos legais);
                Multa eleitoral de {el.multa}; parcelamento das anuidades de {el.parcelamento}.
            </>
        )
    }
    else if (el.tipoinfracao === "12 - Descumprimento dos parâmetros assistenciais fisioterapêuticos.") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de Visita
                Nº {ficha.dadosIniciais[0].tv}/{data}), o descumprimento dos parâmetros assistenciais fisioterapêuticos.
            </>
        )
    }
    else if (el.tipoinfracao === "13 - Descumprimento da Portaria CREFITO-1 Nº 046/2020") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de Visita Nº {ficha.dadosIniciais[0].tv}/{data}),
                o descumprimento da Portaria CREFITO-1 Nº 046/2020.
            </>
        )
    }
    else if (el.tipoinfracao === "14 - Descumprimento da legislação referente ao registro em prontuário dos fisioterapeutas.") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de Visita Nº {ficha.dadosIniciais[0].tv}/{data}),
                o descumprimento da legislação referente ao registro de registro em prontuários dos fisioterapeutas.
            </>
        )
    }
    else if (el.tipoinfracao === "15 - Publicidade irregular - exposição de pacientes.") {
        return (
            <>
                Identificada publicidade contendo exposição de pacientes conforme o Termo de Visita
                Nº {ficha.dadosIniciais[0].tv}/{data}, em descumprimento do Código de Ética e Deontologia da Fisioterapia.
            </>
        )
    }
    else if (el.tipoinfracao === "16 - Publicidade irregular") {
        return (
            <>
                Identificada publicidade contendo: “{el.publicidade}”, conforme o Termo de Visita
                Nº {ficha.dadosIniciais[0].tv}/{data}, em descumprimento do Código de Ética e Deontologia da Fisioterapia
                (Resolução COFFITO nº 424/2013).
            </>
        )
    }
    else if (el.tipoinfracao === "17 - Falta de Registro de Pessoa Jurídica junto ao CREFITO-1.") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de Visita {ficha.dadosIniciais[0].tv}/{data}),
                a falta de Registro de Pessoa Jurídica junto ao CREFITO-1.
            </>
        )
    }
    else if (el.tipoinfracao === "18 - Profissional sem registro de inscrição secundária.") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de
                Visita Nº {ficha.dadosIniciais[0].tv}/{data}), que o autuado(a), apesar de atuar na circunscrição do CREFITO-1, não
                realizou inscrição secundária perante esta autarquia federal.
            </>
        )
    }
    else if (el.tipoinfracao === "19 - Desvio de circunscrição, pois o fisioterapeuta não realizou a transferência.") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de Visita
                Nº {ficha.dadosIniciais[0].tv}/{data}), desvio de circunscrição, pois o fisioterapeuta não realizou a transferência prevista
                pelos art. 84 a 86 da Resolução COFFITO nº 08/1978.
            </>
        )
    }
    else if (el.tipoinfracao === "20 - Falta de cadastro do estabelecimento fiscalizado de Fisioterapia.") {
        return (
            <>
                Identificado, através de fiscalização técnica (conforme o Termo de Visita
                Nº {ficha.dadosIniciais[0].tv}/{data}), a falta de cadastro do estabelecimento fiscalizado nesta
                autarquia federal, tendo em vista que a mesma possui serviços de fisioterapia em suas dependências.
            </>
        )
    }
}